import React from "react";
import PropTypes from "prop-types";
import useExtensionSurfacePreviewState from "../shared/useExtensionSurfacePreviewState";
import ExtensionUpsellWidget from "../shared/ExtensionUpsellWidget";
import {
  ExtensionOrderSummarySidebar,
  ThankYouPageSkeleton,
  pageShellStyles,
} from "../shared/ExtensionPageChrome";
import {
  DUMMY_CUSTOMER,
  SURFACE_WIDGET_BADGES,
} from "../shared/extension-preview-dummy-data";
import styles from "./thank-you-editor-preview.module.css";

export default function ThankYouEditorPreview({ popupData, popupState, setPopupState }) {
  const preview = useExtensionSurfacePreviewState({
    popupData,
    popupState,
    setPopupState,
  });

  return (
    <div
      ref={preview.popupRef}
      className={`${pageShellStyles.pageShell} ${
        preview.isMobile ? pageShellStyles.mobile : ""
      }`.trim()}
      data-testid="thank-you-upsell-preview"
      data-extension-surface="THANK_YOU_PAGE"
    >
      <div className={pageShellStyles.mainPane}>
        <div className={pageShellStyles.mainInner}>
          <header className={styles.header}>
            <div className={styles.checkIcon} aria-hidden>
              ✓
            </div>
            <p className={styles.confirmation}>Confirmation #ABC123EXAMPLE</p>
            <h1 className={styles.title}>
              Thank you, {DUMMY_CUSTOMER.firstName}!
            </h1>
          </header>

          <ExtensionUpsellWidget
            surfaceBadge={SURFACE_WIDGET_BADGES.THANK_YOU_PAGE}
            mapped={preview.mapped}
            popupData={popupData}
            activeStep={preview.activeStep}
            currentParentData={preview.currentParentData}
            selectedBlock={preview.selectedBlock}
            handleBlockClick={preview.handleBlockClick}
            isSelected={preview.isSelected}
            renderCta={preview.renderCta}
          />

          <ThankYouPageSkeleton />
        </div>
      </div>

      <ExtensionOrderSummarySidebar variant="thankYou" />
    </div>
  );
}

ThankYouEditorPreview.propTypes = {
  popupData: PropTypes.object,
  popupState: PropTypes.object,
  setPopupState: PropTypes.func,
};
